<template>
    <div class="offer-list-page" v-if="userAuthenticated">
        <main-navigation></main-navigation>

        <div class="dashboard-header">
            <div class="dashboard-header__new">
                <button
                    @click="openComplaintModal = true"
                    class="btn btn-primary"
                    type="button">
                    <md-icon>add_circle</md-icon> Új reklamáció
                </button>
            </div>

            <div class="dashboard-header__filters">
                <div class="offer-list-page__header-search-flex">
                    <div class="search-container">
                        <search :input="complaintListActiveFilters.search" :searchData="searchData" @searchPhrase="onSearchPhraseChanged"></search>
                    </div>

                    <div class="filter-component input-wrapper">
                        <custom-datepicker
                            :initDate="null"
                            @changed="(el) => {fromDate = el}"
                        />
                    </div>

                    <div class="filter-component input-wrapper">
                        <custom-datepicker
                            :initDate="null"
                            @changed="(el) => {toDate = el}"
                        />
                    </div>
                </div>

                <div class="offer-list-page__header-controls">
                    <button type="button" @click="refresh()">
                        <md-icon>refresh</md-icon>
                    </button>
                </div>
            </div>
        </div>

        <div class="filter-column" :class="{'collapsed-filter-column' : collapsedColumn}">

            <sidebar-filter
                v-if="complaintListFilters"
                :elements="complaintListFilters"
                :selected="complaintListActiveFilters.filter"
                @changed="sidebarChanged" />

            <basic-links position="bottom"></basic-links>

            <div class="button-container">
                <button class="btn btn-plain btn-plain-wicon button-close" type="button" @click="collapsedColumn = true">
                    <md-icon>arrow_back_ios</md-icon>
                </button>
            </div>

            <button class="btn btn-plain btn-plain-wicon button-open" type="button" @click="collapsedColumn = false">
                <md-icon>arrow_forward_ios</md-icon>
            </button>
        </div>

        <div class="list-column" :class="{'collapsed-filter-column' : collapsedColumn}">
            <custom-table
                ref="table"
                :row-height="92"
                :columns="tableColumns"
                :pages="complaintListPages"
                :meta="complaintListMeta"
                @on-cell-click="onCellClick"
                @load-page="loadPage"
                @on-row-mouseleave="onRowMouseleave"
            >
                <template slot="table-row" slot-scope="props">
                    <div class="col-name" v-if="props.column.field === 'id'">
                        <span class="large-line" v-if="props.row.generatedId">{{ props.row.generatedId }}</span>
                    </div>

                    <div class="col-name" v-if="props.column.field === 'type'">
                        <span class="large-line">{{ props.row.type_trans }}</span>
                    </div>

                    <div class="col-name" v-if="props.column.field === 'name'">
                        <span class="small-line">{{ props.row.styledAddress }}</span>
                        <span class="large-line" v-if="props.row.name">{{ props.row.name }}</span>
                    </div>

                    <div class="col-name" v-if="props.column.field === 'status'">
                        <span class="large-line" v-if="props.row.status">{{ $t('complaints.statuses.' + props.row.status) }}</span>
                    </div>

                    <div class="col" v-else-if="props.column.field === 'created_at'">
                        <span class="large-line">{{ props.row.formattedCreatedAt }}</span>
                    </div>

                    <div class="col" v-else-if="props.column.field === 'options'" @click="props.row.showDropdown = !props.row.showDropdown">
                        <button v-if="props.row.actions != null" class="element-options">
                            <md-icon class="element-options">more_vert</md-icon>
                        </button>

                        <dropdown
                            v-if="props.row.actions != null"
                            @clicked="onDropdownClick($event, props.page)"
                            :open="props.row.showDropdown"
                            :options="props.row.actions"
                            :elementId="props.row.id"
                            :elementPayload="props.row.tags" />
                    </div>
                </template>

                <div slot="empty_state">
                    {{ $t('complaints.text.empty_state') }}
                </div>
            </custom-table>
        </div>

        <complaint-modal :open="openComplaintModal" @close="() => {this.openComplaintModal = false}"></complaint-modal>

        <modal-confirmation
            :open="openConfirmationDeleteModal"
            :data="confirmationDeleteModalData"
            @secondaryPrimaryAction="complaintDelete()"
            @accepted="complaintDelete()"
            @close="openConfirmationDeleteModal = false" />

        <notification></notification>

        <div class="is-loading" v-show="loading"></div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

import vClickOutside from 'v-click-outside'

import MainNavigation from '../components/navigations/MainNavigation.vue'
import Search from '../components/Search.vue'
import SidebarFilter from '../components/SidebarFilter.vue'
import BasicLinks from '../components/BasicLinks.vue'
import Dropdown from '../components/dropdowns/Dropdown.vue'
import ModalConfirmation from '../components/modals/ModalConfirmation.vue'
import Notification from '../components/Notification.vue'
import CustomTable from '../components/CustomTable'
import ComplaintModal from '../components/modals/ComplaintModal'
import CustomDatepicker from '../components/dropdowns/CustomDatepicker.vue'
import CustomFilter from '../components/dropdowns/CustomFilter.vue'
import router from '@/router'

export default {
    name: 'ComplaintDamageList',

    data() {
        return {
            loading: true,
            selectedComplaintData: null,
            openComplaintModal: false,

            fromDate: '',
            toDate: '',
            initFromDate: '',
            initToDate: '',

            tableColumns: [
                {
                    label: this.$t('complaints.page.list.column.id'),
                    field: 'id',
                },
                {
                    label: 'Típus',
                    field: 'type',
                },
                {
                    label: this.$t('complaints.page.list.column.status'),
                    field: 'status',
                },
                {
                    label: this.$t('complaints.page.list.column.name'),
                    field: 'name',
                },
                {
                    label: this.$t('complaints.page.list.column.created_at'),
                    field: 'created_at'
                },
                {
                    label: '',
                    field: 'options',
                    width: '80px'
                },
            ],

            showFilters: false,
            collapsedColumn: false,

            deleteComplaintData: null,
            openConfirmationModal: false,

            confirmationModalData: {
                acceptText: this.$t('offer.page.list.confirmation.copy.ok'),
                cancelText: this.$t('offer.page.list.confirmation.copy.cancel'),
                secondaryActionText: this.$t('offer.page.list.confirmation.copy.secondary'),
                message: this.$t('offer.page.list.confirmation.copy.question')
            },

            openConfirmationDeleteModal: false,
            openConfirmationDeleteTagModal: false,
        }
    },

    mounted() {
        this.$store.dispatch('FETCH_CURRENT_USER').then(() => {
            this.$store.dispatch('FETCH_COMPLAINTS', {page: 1, type: 'damage', keepOtherPages: false, onlyMine: true}).then(() => {
                this.loading = false
            })
        })
    },

    methods: {
        complaintDelete() {
            this.openConfirmationDeleteModal = false
            this.$store.dispatch('DELETE_COMPLAINT', {...this.deleteComplaintData}).then(
                this.$store.dispatch('FETCH_COMPLAINTS', {page: 1, type: 'damage', keepOtherPages: false, onlyMine: true})
            )
            this.refresh();
        },

        onSearchPhraseChanged(phrase) {
            if (this.searchTimer) {
                clearTimeout(this.searchTimer)
                this.searchTimer = null
            }

            if (this.complaintListActiveFilters.search === phrase) {
                return
            }

            this.searchTimer = setTimeout(() => {
                this.searchTimer = null
                this.$store.commit('setComplaintListActiveFilters', {
                    ...this.complaintListActiveFilters,
                    search: phrase.length > 0 ? phrase : void 0
                })
                this.refresh()
            }, 300)
        },

        loadPage(page) {
            this.loading = true
            this.$store.dispatch('FETCH_COMPLAINTS', {page: page, type: 'damage', keepOtherPages: true, onlyMine: true}).then(() => {
                this.loading = false
            })
        },

        refresh() {
            this.loading = true
            this.$store.dispatch('FETCH_COMPLAINTS', {page: 1, type: 'damage', keepOtherPages: false, onlyMine: true}).then(() => {
                this.loading = false
                this.$refs.table?.scrollToTop()
            })
        },

        onCellClick(params) {
            if (!params.row.showDropdown && params.column.field !== 'options') {
                this.selectedComplaintData = params.row;
                this.$router.push({name: 'ComplaintEdit', params: {complaintId: this.selectedComplaintData.id}})
            }
        },

        onDropdownClick(val, page) {
            let newData = {}
            let action = typeof val.action === 'string' ? val.action : val.action.action

            switch (action) {
            case 'delete':
                newData = {
                    id: val.id,
                    inList: true,
                    page: page,
                }

                this.openConfirmationDeleteModal = true
                this.deleteComplaintData = newData
                break;
            }
        },

        sidebarChanged(el) {
            this.$store.commit('setComplaintListActiveFilters', {
                ...this.complaintListActiveFilters,
                filter: el
            })
            this.refresh()
        },

        onRowMouseleave(el) {
            el.row.showDropdown = false
        },

        selectedComplaint(data) {
            this.selectedComplaintData = data.complaintData
        },

        setLineBreak(str) {
            if (str === null) {
                return null
            }

            return String(str).replace(/(\S+\s*){1,7}/g, "$&\n")
        },

        filterDates() {
            this.$store.commit('setComplaintListActiveFilters', {
                ...this.complaintListActiveFilters,
                from_date: this.fromDate,
                to_date: this.toDate
            });
            this.refresh();
        },
    },

    directives: {
        clickOutside: vClickOutside.directive
    },

    computed: {
        confirmationDeleteModalData() {
            return {
                acceptText: this.$t('complaints.page.list.confirmation.delete.ok'),
                cancelText: this.$t('complaints.page.list.confirmation.delete.cancel'),
                message: this.$t('complaints.page.list.confirmation.delete.question')
            }
        },

        searchData() {
            return {
                placeholder: this.$t('complaints.page.list.search.placeholder'),
                tooltipText: this.$t('complaints.page.list.search.tooltip')
            }
        },

        ...mapGetters(
            [
                'profile',

                'complaintListPages',
                'complaintListMeta',

                'complaintListFilters',
                'complaintListActiveFilters',

                'userAuthenticated',
                'userCanSeeFilters',
            ])
    },

    components: {
        MainNavigation,
        ComplaintModal,
        Search,
        BasicLinks,
        SidebarFilter,
        Dropdown,
        CustomTable,
        CustomFilter,
        CustomDatepicker,
        ModalConfirmation,
        Notification,
    },

    watch: {
        'fromDate': {
            handler: function () {
                this.filterDates();
            }
        },
        'toDate': {
            handler: function () {
                this.filterDates();
            }
        },
    },
}
</script>

<style lang="scss">
@import '../assets/sass/ui/tooltip.scss';
@import '../assets/sass/ui/vuetable.scss';
</style>

<style lang="scss" scoped>
@import '../assets/sass/toolkit.scss';
@import '../assets/sass/ui/input.scss';
@import '../assets/sass/ui/button.scss';
@import '../assets/sass/ui/tag.scss';
@import '../assets/sass/ui/loading.scss';
@import '../assets/sass/partials/dashboard-header.scss';
@import '../assets/sass/layout/list-page.scss';

.offer-list-page {
    .dashboard-header {
        .search-container {
            width: 100%;
            max-width: 500px;
            min-width: 150px;
            margin: 0px 5px 5px 0px;
        }

        .filter-component {
            margin: 5px 5px 5px 0px;
        }
    }

    &__header-flex {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
    }

    &__header-search-flex {
        width: 100%;
        display: flex;
        align-items: center;
        flex-flow: row wrap;
        align-content: space-between;
    }

    &__header-controls {
        padding-right: 30px;
    }

    .archive-container {
        display: inline-block;
        position: relative;
    }

    .col-name {
        height: 90px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .col-favourite {
        margin-right: 35px;
        width: 80px;
        display: flex;
        align-items: center;

        .i-done {
            // position: relative;
            // top: 4px;
            // left: 7px;
            font-weight: 600;
            color:  $color-green-1;
        }

        button {
            line-height: 18px;

            i {
                margin-top: 5px;
            }

            &.remove {
                i {
                    color: $color-yellow-star;
                }
            }
        }
    }

    .col-options {
        position: relative;
        width: 100px;
    }
}
</style>
